const initialState = {
    data: null,
    token: window.localStorage.chatToken,
    isAuth: !!window.localStorage.chatToken,
    holiday: null
};

export default (state = initialState, {type, payload}) => {
    switch (type) {
        case "USER:SET_DATA":
            return {
                ...state,
                data: payload,
                isAuth: true,
                token: window.localStorage.chatToken
            };
        case "USER:SET_IS_AUTH":
            return {
                ...state,
                isAuth: payload
            };
        case "USER:SET_HOLIDAY":
            return {
                ...state,
                holiday: payload
            };
        case "USER:SET_DIALOG_ID":
            return {
                ...state,
                dialogId: window.localStorage.chatDialogID
            };
        default:
            return state;
    }
};
